(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
AOS.init({
  once: false,
  mirror: true
});

});
  } catch(e) { console.error(e); }
})();

})();
